import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WhatsappApisComponent } from './whatsapp-apis.component';

const routes: Routes = [{
    path: '',
    component: WhatsappApisComponent 
  }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WhatsappApisRoutingModule { }
